import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { addCrossClientClients, addCrossClientFetchedClientIds, setCrossClientResultsClientNameFilter } from '../../../../store/crossClient/crossClientResults'
import { Form } from 'react-bootstrap'
import { useCallback, useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import { useLazyGetAllUsersQuery } from '../../../../store/user/user'
import { selectAccountId } from '../../../../store/auth/authSlice'

export const CrossClientNameFilter = () => {
  const dispatch = useAppDispatch()

  const accountId = useAppSelector(selectAccountId)

  const [clientName, setClientName] = useState<string>('')

  const [triggerGetAllUsers] = useLazyGetAllUsersQuery()

  const filterClients = useCallback(
    async (clientName: string) => {
      if (clientName.length >= 3) {
        const contacts = await triggerGetAllUsers({ accountId, name: clientName }).unwrap()

        if (contacts?.data) {
          const clients = contacts.data.filter((contact) => contact.roles.some((role) => role.name === 'Client'))
          dispatch(addCrossClientFetchedClientIds(clients.map((c) => c.id)))
          dispatch(addCrossClientClients(clients))
        }
      }
      dispatch(setCrossClientResultsClientNameFilter(clientName))
    },
    [dispatch, accountId, triggerGetAllUsers],
  )

  const handleClientNameChanged = useDebouncedCallback(filterClients, 300)

  return (
    <div className='d-flex gap-2 align-items-center form-control zocks-px-0.75 zocks-py-0.375 w-auto'>
      <i className='bi bi-search fs-6'></i>
      <Form.Control
        className='p-0 border-0'
        type='text'
        value={clientName}
        onChange={(e) => {
          setClientName(e.currentTarget.value)
          handleClientNameChanged(e.currentTarget.value)
        }}
        placeholder='Search client'
      />
    </div>
  )
}
